<template>
<panel>
    <p slot="header">
        {{ item.email }} <span class="gray">(adres e-mail)</span>
    </p>
    <table class="table info-table">
        <tbody>
            <tr>
                <th class="short">
                    Należy do grup
                </th>
                <td>
                    <p v-for="g in item.groups">
                        <a @click.prevent="$router.push({name: 'admin.email-groups.show', params: {id: g.id}})">{{ g.name }}</a>
                    </p>
                </td>
            </tr>
            <tr>
                <th>
                    Status
                </th>
                <td>
                    <email-status :item="item" v-if="item"></email-status>
                </td>
            </tr>
            <tr>
                <th>
                    Zaimportowany
                </th>
                <td>
                    <div v-if="item.was_imported">
                        <span class="label-black">Tak.</span> <span class="label">{{ item.imported_at_formated }}</span>
                    </div>
                    <div v-if="!item.was_imported">
                        <span class="label">Nie</span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <p slot="actions">
        <ui-button type="flat" icon="navigate_before" color="primary" @click.prevent="$router.push({name: 'admin.emails.dashboard'})">Wróć</ui-button>
        <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.emails.edit', params: {id: id}})">Edytuj adres e-mail</ui-button>
    </p>

</panel>

</template>
<script>
import Emails from './../../services/Emails'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Emails.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getItem(this.id)
  },
  methods: {
    getItem (id) {
      this.setLoading(true)
      Emails.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Show.vue?8c519058